import React, {useState} from "react";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import RecommendedDeleteMessage from "../messages/RecommendedDeleteMessage";
import {useRecommendedContext} from "../../../context/recommended/RecommendedContext";

const RecommendedSettingDelete = () => {
    const {
        config,
    } = useRecommendedContext();

    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const handleDeleteModalOpen = () => setOpenDeleteModal(true);
    const handleDeleteModalClose = () => setOpenDeleteModal(false);

    return (
        <>
            <button
                disabled={config.isValidating}
                className="btn btn-red"
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "fit-content",
                }}
                onClick={handleDeleteModalOpen}
            >
                <DeleteForeverIcon/>
            </button>
            <RecommendedDeleteMessage
                openDeleteModal={openDeleteModal}
                handleDeleteModalClose={handleDeleteModalClose}
            />
        </>
    );
};

export default RecommendedSettingDelete;
